import template from './template.html';
import controller from './controller';

const controllerAs = 'CpeCatalogCardsCtrl';

const bindings = {
  events: '<',
  locationSearch: '<',
  pageSize: '<',
  pageTitle: '<',
  sortType: '<',
  state: '<',
  type: '<',
  toggle: '&'
};

export default {
  template,
  controller,
  controllerAs,
  bindings
};



// WEBPACK FOOTER //
// ./src/app/components/cpeCatalog/cards/index.js